import { useRef, useState } from 'react';
import GetIcon from '../../../utils/Icon';

const NewMultiFileInput = ({ name, setFile, error, style = {} }) => {
    const inputRef = useRef(null);
    const [fileList, setFileList] = useState([]);
    const [focused, setFocused] = useState(false);

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const prefix = name.toLowerCase().replace(/[^a-z0-9]/gi, '_');

        const renamedFiles = files.map(file => {
            const ext = file.name.split('.').pop();
            const randomStr = Math.random().toString(36).substring(2, 6);
            const newName = `${prefix}_${randomStr}.${ext}`;
            return new File([file], newName, { type: file.type });
        });

        const updated = [...fileList, ...renamedFiles];
        setFileList(updated);
        setFile(updated);
    };

    const triggerFileInput = () => {
        if (inputRef.current) {
            inputRef.current.click();
        }
    };

    const removeFile = (index) => {
        const updatedList = [...fileList];
        updatedList.splice(index, 1);
        setFileList(updatedList);
        setFile(updatedList);
    };

    // Default styles with overrides from props
    const containerStyle = {
        height: style.height || '30px',
        width: style.width || '100%',
        background: style.background || "white",
        borderRadius: style.borderRadius || '8px',
        ...style
    };

    const mainContainerStyle = {
        position: 'relative',
        height: style.height || '30px',
        overflow: 'hidden'
    };

    const buttonWidth = style.buttonWidth || '100px';
    const fileListMargin = style.buttonWidth ? `calc(${style.buttonWidth} + 8px)` : '108px';

    return (
        <div className="position-relative" style={{ width: style.width || '100%' }}>
            {/* Label on top */}
            <label
                htmlFor={name}
                style={{
                    fontSize: '12px',
                    fontWeight: '500',
                    marginBottom: '4px',
                    display: 'block',
                    color: '#333'
                }}
            >
                {name}
            </label>

            <div style={containerStyle}>
                <div
                    className={`rounded px-1 ${error ? 'errorborder' : 'border'}`}
                    style={mainContainerStyle}
                >
                    <div
                        className="flex flex-wrap items-center gap-1"
                        style={{
                            height: '100%',
                            marginLeft: fileListMargin,
                            marginRight: '4px',
                            overflowY: 'auto'
                        }}
                    >
                        {fileList.map((file, index) => (
                            <span
                                key={index}
                                className="flex items-center"
                                style={{
                                    background: '#EDEDED',
                                    color: '#5E6366',
                                    borderRadius: '12px',
                                    padding: '0 6px',
                                    fontSize: '8px',
                                    height: '18px',
                                    lineHeight: '18px',
                                    flexShrink: 0
                                }}
                            >
                                {file.name}
                                <button
                                    type="button"
                                    onClick={() => removeFile(index)}
                                    className="ml-1"
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        fontSize: '10px',
                                        marginLeft: '6px',
                                        cursor: 'pointer',
                                        color: '#333',
                                    }}
                                >
                                    ×
                                </button>
                            </span>
                        ))}
                    </div>

                    <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={triggerFileInput}
                        style={{
                            position: 'absolute',
                            left: '4px',
                            top: '4px',
                            height: '20px',
                            width: buttonWidth,
                            padding: '0 6px',
                            fontSize: '10px',
                            background: '#DEDEDE',
                            color: 'black',
                            border: 'none',
                        }}
                    >
                        <GetIcon iconName="MdOutlineFileUpload" size={12} /> Choose File
                    </button>

                    <input
                        type="file"
                        ref={inputRef}
                        onChange={handleFileChange}
                        onFocus={() => setFocused(true)}
                        onBlur={() => setFocused(false)}
                        multiple
                        accept="image/*"
                        style={{ display: 'none' }}
                    />
                </div>
            </div>
        </div>
    );
};

export default NewMultiFileInput;